import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M4 13.9194V2.08062C4 1.24212 4.96993 0.775946 5.6247 1.29976L12.0478 6.43826C13.0486 7.23891 13.0486 8.76109 12.0478 9.56174L5.6247 14.7002C4.96993 15.2241 4 14.7579 4 13.9194Z" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;